import type { MeetingClient } from "./table-call.context.js";
import type { TableCallRuntime, TableCallTarget } from "./table-call.types.js";

export const assignRuntimeMeeting = (
  runtime: TableCallRuntime,
  meeting: MeetingClient,
  target: TableCallTarget
): void => {
  runtime.meetingRef.current = meeting;
  runtime.activeTargetRef.current = target;
};

export const clearRuntimeMeeting = (runtime: TableCallRuntime): void => {
  runtime.meetingRef.current = null;
  runtime.activeTargetRef.current = null;
};

export const clearRuntimeReconnect = (runtime: TableCallRuntime): void => {
  runtime.isReconnectingRef.current = false;
  runtime.reconnectReasonRef.current = null;
};

export const incrementRuntimeOperationGeneration = (
  runtime: TableCallRuntime
): void => {
  runtime.operationGenerationRef.current += 1;
};

export const isRuntimeReconnecting = (runtime: TableCallRuntime): boolean =>
  runtime.isReconnectingRef.current;

export const resetRuntimeRecoveryCounters = (
  runtime: TableCallRuntime
): void => {
  const counters = runtime.audioRecoveryCountersRef.current;
  counters.microphoneSameDeviceAttempts = 0;
  counters.microphoneFallbackAttempts = 0;
  counters.speakerFallbackAttempts = 0;
  runtime.lastRemoteFailureReportKeyRef.current = null;
};

export const setRuntimeMounted = (
  runtime: TableCallRuntime,
  isMounted: boolean
): void => {
  runtime.isMountedRef.current = isMounted;
};

export const setRuntimeDesiredTarget = (
  runtime: TableCallRuntime,
  target: TableCallTarget | null
): void => {
  runtime.desiredTargetRef.current = target;
};

export const setRuntimeScheduleTransition = (
  runtime: TableCallRuntime,
  scheduleTransition: () => void
): void => {
  runtime.scheduleTransitionRef.current = scheduleTransition;
};

export const startRuntimeReconnect = (
  runtime: TableCallRuntime,
  reason: string
): void => {
  runtime.isReconnectingRef.current = true;
  runtime.reconnectRequestIdRef.current += 1;
  runtime.reconnectReasonRef.current = reason;
};
